import { action, computed, observable } from 'mobx';
import { UiResponse } from '../CommonInterfaces';
import { API } from '../util/ApiUtil';
import ErrorUtil from '../util/ErrorUtil';
import BaseLoginStore from './BaseLoginStore';
import RootStore from './RootStore';

interface PasswordChangeParams {
  authId: string;
  softAuth?: boolean;
  invalidTokenMessageParams?: string;
  goto?: string;
}

export interface PasswordChangeInitResponse extends UiResponse {
  params?: PasswordChangeParams;
}

export interface EmailLoginPasswords {
  oldPassword: string;
  password: string;
  confirmPassword: string;
}

export default class PasswordChangeStore extends BaseLoginStore {
  @observable accessor emailLoginPasswords: EmailLoginPasswords = { oldPassword: '', password: '', confirmPassword: '' };
  @observable accessor passwordChangeInitResponse: PasswordChangeInitResponse | null = null;
  @observable accessor isChangePasswordModalOpen: boolean = false;

  constructor(rootStore: RootStore) {
    super(rootStore);
  }

  public async init() {
    await this.getInitialPasswordChangeProps();
  }

  @computed
  public get softAuthChange(): boolean {
    return this.passwordChangeInitResponse?.params?.softAuth || false;
  }

  @computed
  public get shouldSetEmail() {
    return this.passwordChangeInitResponse?.params?.invalidTokenMessageParams;
  }

  @computed
  public get initialResponseNotice() {
    return this.passwordChangeInitResponse?.notice?.children;
  }

  public async handleLogin(callback?: () => void) {
    if (!this.passwordChangeInitResponse?.params?.authId) {
      ErrorUtil.pushErrorToTeliaRumAndLogWithLocation('this.passwordChangeInitResponse?.params?.authId does not have a value');
      return;
    }
    await this.handleLoginTemplate(
      '/email/change-password',
      this.emailLoginPasswords,
      { headers: { authId: this.passwordChangeInitResponse.params.authId } },
      callback,
    );
  }

  @action.bound
  public resetPasswordForm() {
    this.emailLoginPasswords = { oldPassword: '', password: '', confirmPassword: '' };
  }

  public async getInitialPasswordChangeProps() {
    try {
      this.resetPasswordForm();
      const response = await API.get(`/email/initialize-pw-change${this.routeStore.formForwardParams}`);
      this.passwordChangeInitResponse = response.data;
    } catch (e: Error | string | any) {
      this.handleError(e);
    }
  }

  @action.bound
  public handleChangePasswordModalOpen(isOpen: boolean) {
    this.isChangePasswordModalOpen = isOpen;
  }
}
